<template>
  <div>
    <div class="modal fade" tabindex="-1" :class="{ show: showModal }">
      <div class="modal-dialog">
        <div class="modal-content">
          <addTemplateModal :selectedArtboard="selectedArtboard"
            v-if="showAddTemplateModal == true"
            @close-add-template-modal="showAddTemplateModal = false"
            @refresh-templates="getTemplates()"
          />
          <editTemplateModal :selectedTemplate="selectedTemplate"
            v-if="showEditTemplateModal == true"
            @close-edit-template-modal="showEditTemplateModal = false"
            @refresh-templates="getTemplates()"
          />
          <deleteConfirmationModal
            v-if="showDeleteConfirmationModal"
            :delete-function="deleteTemplate"
            @close-delete-confirmation-modal="showDeleteConfirmationModal = false"
            @refresh-records="getTemplates()"
          />
          <div class="modal-header">
            <h6 class="modal-title">Templates</h6>
            <button
              type="button"
              class="btn btn-light"
              style="float: right; padding-bottom: 0px"
              @click="closeModal()"
              aria-label="Close"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>
          <div class="row justify-content-end">
            <div class="col-auto">
              <button v-on:click="showAddTemplateModal = true" class="btn btn-link-custom-primary">
                Add Template
              </button>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-5">
              <input
                v-model="searchTerm"
                type="text"
                class="form-control"
                id="searchTemplate"
                placeholder="Search by Name"
              />
            </div>
          </div> -->
          <div class="row">
            <div class="col-12">
              <tableShimmer v-if="templatesIsLoading" />
              <div v-else class="table-card">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Name</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody v-if="templates && templates.length > 0">
                    <template
                      v-bind:key="index"
                      v-for="(template, index) in templates"
                    >
                      <tr :class="[isOdd(index + 1) ? 'striped' : null]">
                        <th scope="row">
                          {{
                            `${currentPage > 1 ? currentPage - 1 : ''}${index + 1}`
                          }}
                        </th>
                        <td>
                          <span class="template-name">{{ template.name }}</span>
                          <span v-if="customFieldCount(template)" class="template-fields-count">
                            {{ customFieldCount(template) }} field{{ customFieldCount(template) === 1 ? '' : 's' }}
                          </span>
                        </td>
                        <td>
                          <div class="dropdown dropleft">
                            <div
                              class="avatar dropdown-toggle actions-dropdown"
                              type="button"
                              data-toggle="dropdown"
                            >
                              <i class="pi pi-ellipsis-h"></i>
                            </div>
                            <div
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton"
                            >
                              <a
                                class="dropdown-item"
                                v-on:click="selectTemplateToEdit(template)"
                                >Edit</a
                              >
                              <!-- <a
                                class="dropdown-item"
                                v-on:click="selectTemplateToView(template)"
                                >View</a
                              > -->
                              <a
                                class="dropdown-item final-item text-danger"
                                v-on:click="
                                  toggleDeleteConfirmationModal(template)
                                "
                                >Delete</a
                              >
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">
                        <p
                          class="mt-2 d-flex justify-content-center align-items-center"
                          style="height: 100%"
                        >
                          No Templates found
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="pagination">
                  <vue-awesome-paginate
                    v-if="templatesMetaData"
                    :total-items="templatesMetaData.totalRecords"
                    :items-per-page="templatesMetaData.perPage"
                    :max-pages-shown="Math.max(templatesMetaData.totalPages, 1)"
                    v-model="currentPage"
                    @click="getVehicles"
                  >
                    <template #prev-button>
                      <span
                        v-on:click="prev()"
                        :class="currentPage <= 1 ? 'disabled' : null"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="white"
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M8.122 24l-4.122-4 8-8-8-8 4.122-4 11.878 12z"
                          />
                        </svg>
                      </span>
                    </template>

                    <template #next-button>
                      <span
                        v-on:click="next()"
                        :class="
                          currentPage >= templatesMetaData.totalPages
                            ? 'disabled'
                            : null
                        "
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="white"
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M8.122 24l-4.122-4 8-8-8-8 4.122-4 11.878 12z"
                          />
                        </svg>
                      </span>
                    </template>
                  </vue-awesome-paginate>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import addTemplateModal from '@/components/template/Add_Template_Modal.vue';
import editTemplateModal from '@/components/template/Edit_Template_Modal.vue';
import deleteConfirmationModal from '@/components/Delete_Confirmation_Modal.vue';
import tableShimmer from '@/components/shimmers/Table.Shimmer.vue';

import { Field, Form, ErrorMessage, defineRule } from 'vee-validate';
import { DELETE_TEMPLATE, GET_TEMPLATES } from '@/store/action_types';

defineRule('required', (value, [fieldName = 'Field']) => {
  if (!value || value.length === 0) {
    return `${fieldName} is required`;
  }
  return true;
});
defineRule('alpha', (value, [fieldName = 'Field']) => {
  const alphaRegExp = /^[a-zA-Z]*$/;
  return (
    alphaRegExp.test(value) ||
    `${fieldName} must contain only alphabetic characters`
  );
});

export default {
  props: {
    selectedArtboard: {
      type: Object,
      required: true
    },
  },
  components: {
    Field,
    Form,
    ErrorMessage,
    addTemplateModal,
    editTemplateModal,
    deleteConfirmationModal,
    tableShimmer
  },
  data() {
    return {
      showModal: true,
      currentPage: 1,
      showAddTemplateModal: false,
      showEditTemplateModal: false,
      showDeleteConfirmationModal: false,
      selectedTemplate: null,
    };
  },
  computed: {
    donation() {
      return this.$store.getters.donation.data;
    },
    donationIsLoading() {
      return this.$store.getters.donation.isLoading;
    },
    templates() {
      return this.$store.getters.templates.data;
    },
    templatesIsLoading() {
      return this.$store.getters.templates.isLoading;
    },
    templatesMetaData() {
      return this.$store.getters.templates.metaData;
    },
    account() {
      return this.$store.getters.account.data;
    },
  },
  methods: {
    isOdd(number) {
      return number % 2 !== 0;
    },
    customFieldCount(template) {
      return Array.isArray(template.customVariables) ? template.customVariables.length : 0;
    },
    closeModal() {
      this.$emit('closeTemplatesModal');
    },
    toggleDeleteConfirmationModal(template) {
      this.selectedTemplate = template

      this.showDeleteConfirmationModal = true;
    },
    deleteTemplate() {
      return this.$store.dispatch(DELETE_TEMPLATE, this.selectedTemplate.id);
    },
    selectTemplateToEdit(template) {
      this.selectedTemplate = template;
      this.showEditTemplateModal = true;
    },
    getTemplates() {
      this.$store.dispatch(GET_TEMPLATES, { organizationId: this.account.organizationId })
    },
  },
  mounted() {
    this.getTemplates()
  },
};
</script>

<style scoped>
.modal-content {
  border-radius: 20px !important;
  border: 1px solid transparent;
  background-color: #fdfdfe !important;
  max-height: 92vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  display: none;
}

.modal.show {
  display: block;
}

.modal-dialog {
  max-width: 50%;
}

.template-name {
  display: block;
}

.template-fields-count {
  display: block;
  margin-top: 2px;
  font-size: 0.72rem;
  color: var(--color-text-muted);
}

.modal {
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.modal-content {
  border: 1px solid #e4e4e7;
}

.modal-header {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom: 1px solid #e4e4e7;
}

.modal-header .modal-title {
  position: relative;
  top: 8px;
  font-size: 1.1rem;
}

.image-container {
  position: relative;
  display: inline-block;
  margin-top: 1rem;
}

.artboard-box {
  box-sizing: border-box;
}

.modal-footer {
  border-top: 1px solid #e4e4e7;
}

@media (min-width: 1000px) {
  .modal-dialog {
    max-width: 20%;
  }
}
</style>
